import { themes } from 'kb-shared';
import styled from 'styled-components';

export const MailingWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 50%;

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    width: 100%;
  }
`;

export const AddressRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-contect: center;
  align-items: flex-start;
  width: 100%;

  label {
    text-transform: uppercase;
  }

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    flex-direction: column;
  }
`;

export const CityWrapper = styled.div`
  width: 50%;
  max-width: 340px;
  margin-right: 20px;

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    width: 100%;
  }
`;

export const CountryWrapper = styled.div`
  padding: 0 0 12px 0;
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-right: 20px;
  width: 50%;

  label {
    text-transform: uppercase;
  }

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    width: 100%;
  }
`;

export const EmailDetail = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${({ theme }) => theme.colors.gray};
  font-size: 14px;
`;

export const EmailValue = styled.div`
  ${({ theme }) => theme.fonts.DomaineDisplay};
  color: ${({ theme }) => theme.colors.KBNight};
  line-height: 40px;
  font-size: 24px;
  margin-bottom: 15px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;

  .address1-field {
    margin-right: 20px;
  }

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    flex-direction: column;
  }
`;
